export const API_URL = import.meta.env.VITE_API_URL;
export const WS_URL = import.meta.env.VITE_WS_URL || "wss://api-guidepro.sismael.com";

// Log pour débogage
// console.log("API_URL value:", API_URL);
// console.log("VITE_API_URL env:", import.meta.env.VITE_API_URL);
// console.log("All env variables:", import.meta.env);

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_URL}/api/v1/auth/login`,
    REGISTER: `${API_URL}/api/v1/users`,
    UPDATE_USER: (id: string) => `${API_URL}/api/v1/users/${id}`,
    IMPORT_USERS: `${API_URL}/api/v1/users/import/excel`,
    SWITCH_ROLE: `${API_URL}/api/v1/auth/switch-role`,
    LOGOUT: `${API_URL}/api/v1/auth/logout`,
    GET_USERS: `${API_URL}/api/v1/users`,
    FORGOT_PASSWORD: `${API_URL}/api/v1/auth/forgot-password`,
    RESET_PASSWORD: `${API_URL}/api/v1/auth/reset-password`,
    VERIFY_EMAIL: `${API_URL}/api/v1/auth/verify-email`,
    VERIFY_RESET_TOKEN: `${API_URL}/api/v1/auth/verify-reset-token`,
    RESEND_VERIFICATION: `${API_URL}/api/v1/auth/resend-verification`,
    GET_TEACHERS: `${API_URL}/api/v1/users/teachers/all`,
    UPLOAD_FILE: `${API_URL}/api/v1/upload`,
  },
  MINISTRIES: {
    GET_MINISTRIES: `${API_URL}/api/v1/ministries`,
    GET_MINISTRY_BY_ID: (id: number) => `${API_URL}/api/v1/ministries/${id}`,
    CREATE_MINISTRY: `${API_URL}/api/v1/ministries`,
    UPDATE_MINISTRY: (id: number) => `${API_URL}/api/v1/ministries/${id}`,
    DELETE_MINISTRY: (id: number) => `${API_URL}/api/v1/ministries/${id}`,
  },

  CONTACT: {
    SEND_MESSAGE: `${API_URL}/api/v1/contact`,
    GET_MESSAGES: `${API_URL}/api/v1/contact`,
    MARK_AS_READ: (id: string) =>
      `${API_URL}/api/v1/contact/${id}/mark-as-read`,
    UPDATE_STATUS: (id: string) =>
      `${API_URL}/api/v1/contact/${id}/update-status`,
  },
  CINEPRO: {
    CREATE_MODULE: `${API_URL}/api/v1/cours/modules`,
    GET_MODULES: `${API_URL}/api/v1/cours/modules`,
    UPDATE_MODULE: (id: string) => `${API_URL}/api/v1/cours/modules/${id}`,
    DELETE_MODULE: (id: string) => `${API_URL}/api/v1/cours/modules/${id}`,
    GET_CAPSULES: (id: string) => `${API_URL}/api/v1/cours/${id}`,
    GET_MODULE_COURSES: (moduleId: string) =>
      `${API_URL}/api/v1/cours/module/${moduleId}`,
    CREATE_CAPSULE: `${API_URL}/api/v1/cours`,
    UPDATE_CAPSULE: (moduleId: string, capsuleId: string) =>
      `${API_URL}/api/v1/cours/modules/${moduleId}/capsules/${capsuleId}`,
    DELETE_CAPSULE: (moduleId: string, capsuleId: string) =>
      `${API_URL}/api/v1/cours/modules/${moduleId}/capsules/${capsuleId}`,
    GET_MODULE_BY_ID_WITH_OTHER_GREYED_OUT: (moduleId: string) =>
      `${API_URL}/api/v1/cours/modules/${moduleId}`,
    GET_PROGRESSION: `${API_URL}/api/v1/cours/progression`,
    RECALCULATE_PROGRESSION: `${API_URL}/api/v1/cours/progression/recalculate-all`,
    GET_ALL_COURSE_PROGRESSIONS: `${API_URL}/api/v1/cours/progression/cours`,
    MARK_MODULE_COMPLETED: (moduleId: string) =>
      `${API_URL}/api/v1/cours/modules/${moduleId}/complete`,
    UPDATE_MODULE_PROGRESSION: (moduleId: string) =>
      `${API_URL}/api/v1/cours/modules/${moduleId}/progression`,
    GET_COURSE_PROGRESSION: (courseId: string) =>
      `${API_URL}/api/v1/cours/cours/${courseId}/progression`,
    UPDATE_COURSE_PROGRESSION: (courseId: string) =>
      `${API_URL}/api/v1/cours/cours/${courseId}/progression`,
    GET_MODULE_PROGRESSIONS: (moduleId: string) =>
      `${API_URL}/api/v1/cours/module/${moduleId}/accessible`,
    GET_COURSE_QUIZZES: (courseId: string) =>
      `${API_URL}/api/v1/cours/cours/${courseId}/quizzes`,
    GET_MODULE_PROGRESSION_COURSES: (moduleId: string) =>
      `${API_URL}/api/v1/cours/progression/module/${moduleId}/cours`,
  },
  RESOURCES: {
    GET_RESOURCES: `${API_URL}/api/v1/resources`,
    CREATE_RESOURCE: `${API_URL}/api/v1/resources`,
    UPDATE_RESOURCE: (id: string) => `${API_URL}/api/v1/resources/${id}`,
    DELETE_RESOURCE: (id: string) => `${API_URL}/api/v1/resources/${id}`,
    DOWNLOAD_RESOURCE: (id: string) =>
      `${API_URL}/api/v1/resources/${id}/download`,
  },
  FORUM: {
    CREATE_CATEGORY: `${API_URL}/api/v1/forum/categories`,
    GET_CATEGORIES: `${API_URL}/api/v1/forum/categories`,
    UPDATE_CATEGORY: (id: string) => `${API_URL}/api/v1/forum/categories/${id}`,
    DELETE_CATEGORY: (id: string) => `${API_URL}/api/v1/forum/categories/${id}`,
    CREATE_TOPIC: `${API_URL}/api/v1/forum/topics`,
    GET_TOPICS: `${API_URL}/api/v1/forum/topics`,
    DELETE_TOPIC: (id: string) => `${API_URL}/api/v1/forum/topics/${id}`,
    UPDATE_TOPIC: (id: string) => `${API_URL}/api/v1/forum/topics/${id}`,
    GET_TOPIC_COMMENTS: (topicId: string) =>
      `${API_URL}/api/v1/forum/topics/${topicId}/posts`,
    CREATE_COMMENT: `${API_URL}/api/v1/forum/posts`,
    UPDATE_COMMENT: (id: string) => `${API_URL}/api/v1/forum/posts/${id}`,
    DELETE_COMMENT: (topicId: string, commentId: string) =>
      `${API_URL}/api/v1/forum/topics/${topicId}/comments/${commentId}`,
  },
  QUIZZ: {
    CREATE_QUIZZ: `${API_URL}/api/v1/quizzes`,
    GET_ALL_QUIZZES: `${API_URL}/api/v1/quizzes`,
    GET_QUIZZ_BY_ID: (id: string) => `${API_URL}/api/v1/quizzes/${id}`,
    UPDATE_QUIZZ: (id: string) => `${API_URL}/api/v1/quizzes/${id}`,
    DELETE_QUIZZ: (id: string) => `${API_URL}/api/v1/quizzes/${id}`,
    START_QUIZZ: (id: string) => `${API_URL}/api/v1/quizzes/${id}/start`,
    SUBMIT_ANSWER: (attemptId: string) =>
      `${API_URL}/api/v1/quizzes/${attemptId}/answers`,
    COMPLETE_QUIZZ: (attemptId: string) =>
      `${API_URL}/api/v1/quizzes/${attemptId}/complete`,
    GET_QUIZZES_BY_COURSE_ID: (courseId: string) =>
      `${API_URL}/api/v1/courses/${courseId}/quizzes`,
    GET_QUIZZ_FOR_COURSE: (courseId: string) =>
      `${API_URL}/api/v1/courses/${courseId}/quiz`,
  },
  CHAT: {
    CREATE_MESSAGE: `${API_URL}/api/v1/chat/messages`,
    GET_CHANNEL_MESSAGES: (channelId: string) =>
      `${API_URL}/api/v1/chat/channels/${channelId}/messages`,
    GET_PRIVATE_MESSAGES: (userId: string) =>
      `${API_URL}/api/v1/chat/conversations/${userId}/messages`,
    MARK_AS_READ: (userId: string) =>
      `${API_URL}/api/v1/chat/conversations/${userId}/read`,
    GET_UNREAD_COUNT: `${API_URL}/api/v1/chat/messages/unread/count`,
    CREATE_CHANNEL: `${API_URL}/api/v1/chat/channels`,
    GET_ALL_CHANNELS: `${API_URL}/api/v1/chat/channels`,
    UPDATE_CHANNEL: (channelId: string) =>
      `${API_URL}/api/v1/chat/channels/${channelId}`,
    GET_CHANNEL_BY_ID: (channelId: string) =>
      `${API_URL}/api/v1/chat/channels/${channelId}`,
    JOIN_CHANNEL: (channelId: string) =>
      `${API_URL}/api/v1/chat/channels/${channelId}/join`,
    LEAVE_CHANNEL: (channelId: string) =>
      `${API_URL}/api/v1/chat/channels/${channelId}/leave`,
    GET_USER_CONVERSATIONS: `${API_URL}/api/v1/chat/conversations`,
  },
  MEETINGS: {
    CREATE_MEETING: `${API_URL}/api/v1/meetings`,
    GET_ALL_MEETINGS: `${API_URL}/api/v1/meetings`,
    GET_MEETINGS_BY_USER: `${API_URL}/api/v1/meetings/my-meetings`,
    GET_MEETING_BY_ID: (id: string) => `${API_URL}/api/v1/meetings/${id}`,
    UPDATE_MEETING: (id: string) => `${API_URL}/api/v1/meetings/${id}`,
    DELETE_MEETING: (id: string) => `${API_URL}/api/v1/meetings/${id}`,
    ZOOM_WEBHOOK: `${API_URL}/api/v1/webhooks/zoom`,
    GET_ZOOM_SIGNATURE: `${API_URL}/api/v1/meetings/zoom-signature`,
    ZOOM_PROXY: {
      PROXY_PATH: (path: string) => `${API_URL}/api/v1/zoom-proxy/${path}`,
      BASE: `${API_URL}/api/v1/zoom-proxy`,
      SETUP_SCRIPT: `${API_URL}/api/v1/meet/scripts/setup-frontend-proxy.js`,
      SDK: {
        REACT: (version: string) =>
          `${API_URL}/api/v1/zoom-proxy/react?v=${version}`,
        SDK: (version: string) =>
          `${API_URL}/api/v1/zoom-proxy/sdk?v=${version}`,
        CSS: `${API_URL}/api/v1/zoom-proxy/css/styles.wc_meeting.min.css`,
      },
      PING: `${API_URL}/api/v1/zoom-proxy/ping`,
      EMBED_MEETING: (meetingId: string) =>
        `${API_URL}/api/v1/zoom-proxy/embed/meeting/${meetingId}`,
    },
  },
  ZOOM: {
    WEBHOOKS: `${API_URL}/api/v1/webhooks/zoom`,
    PROXY: {
      BASE: `${API_URL}/api/v1/zoom-proxy`,
      WITH_PATH: (path: string) => `${API_URL}/api/v1/zoom-proxy/${path}`,
    },
    SCRIPTS: {
      SETUP_FRONTEND_PROXY: `${API_URL}/api/v1/meet/scripts/setup-frontend-proxy.js`,
    },
  },
} as const;

export const WS_ENDPOINTS = {
  CHAT: {
    MAIN: `${WS_URL}/chat`,
  },
} as const;
